import { useEffect } from 'react';

export const useTheiaAutoPause = (userId: string | number | undefined, isActive: boolean = true) => {
    useEffect(() => {
        if (!isActive || !userId) return;

        const handleUnload = () => {
            const apiUrl = process.env.REACT_APP_API_URL;
            if (apiUrl && userId) {
                navigator.sendBeacon(`${apiUrl}:8061/jutge/ide/pause/${userId}`);
            }
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleUnload);
            // Si el componente se desmonta o isActive pasa a false, mandamos la pausa
            handleUnload();
        };
    }, [userId, isActive]);
};
